"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const notification_service_1 = require("./notification.service");
const send_notification_dto_1 = require("./dto/send-notification.dto");
const response_util_1 = require("../../../../service-lib/src/lib/response.util");
const get_notification_dto_1 = require("./dto/get-notification.dto");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const update_status_dto_1 = require("./dto/update-status.dto");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
let NotificationController = class NotificationController {
    constructor(notificationService) {
        this.notificationService = notificationService;
    }
    async send(dto, res) {
        try {
            if (dto && !dto.emailId && !dto.userId) {
                return (0, response_util_1.createResponse)(400, messages_1.errorMessages.notificationUserRequired, null);
            }
            const result = await this.notificationService.sendNotification(dto);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.notificationRetrieved, result));
        }
        catch (error) {
            console.log('Error sending notification:', error);
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.notificationSendFailed, error));
        }
    }
    async getNotifications(query, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const { page, limit, status } = query;
            const result = await this.notificationService.getNotifications(userId, page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, status);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.notificationRetrieved, result));
        }
        catch (error) {
            console.log('Error retrieving notifications:', error);
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.notificationRetrievalFailed, error));
        }
    }
    async checkLatestNotification(notificationId, status, res) {
        try {
            const result = await this.notificationService.checkLatestNotification(notificationId, status);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.notificationRetrieved, result));
        }
        catch (error) {
            console.log('Error retrieving latest notification:', error);
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.notificationRetrievalFailed, error));
        }
    }
    async updateReadStatus(updateStatus, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const result = await this.notificationService.updateReadStatus(updateStatus.id, updateStatus.status, userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.notificationUpdated, result));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_util_1.createResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.notificationUpdateFailed, error));
        }
    }
};
exports.NotificationController = NotificationController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_b = typeof send_notification_dto_1.SendNotificationDto !== "undefined" && send_notification_dto_1.SendNotificationDto) === "function" ? _b : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NotificationController.prototype, "send", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof get_notification_dto_1.GetNotificationDto !== "undefined" && get_notification_dto_1.GetNotificationDto) === "function" ? _c : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NotificationController.prototype, "getNotifications", null);
tslib_1.__decorate([
    (0, common_1.Get)('check-latest-notification'),
    tslib_1.__param(0, (0, common_1.Query)('notificationId')),
    tslib_1.__param(1, (0, common_1.Query)('status')),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NotificationController.prototype, "checkLatestNotification", null);
tslib_1.__decorate([
    (0, common_1.Put)('update-status'),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_d = typeof update_status_dto_1.UpdateStatusDto !== "undefined" && update_status_dto_1.UpdateStatusDto) === "function" ? _d : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], NotificationController.prototype, "updateReadStatus", null);
exports.NotificationController = NotificationController = tslib_1.__decorate([
    (0, common_1.Controller)('notifications'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof notification_service_1.NotificationService !== "undefined" && notification_service_1.NotificationService) === "function" ? _a : Object])
], NotificationController);
